/**
 * App entry point. Boots the Shell, which pulls in Core, Render, and the Backend
 * client. Keep this file tiny — it is glue.
 *
 * Service-worker registration + install/update UX are owned by the Shell (see
 * src/shell/ui/install.ts) and happen inside bootGame, so they are NOT duplicated
 * here.
 */

import { bootGame } from '@/shell';
import { createSimulation } from '@/core';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

// Go live with Core's real deterministic physics. (Course generation and the
// renderer already auto-use the real @/core and @/render modules; the sim is the
// one factory Shell leaves injectable, so we wire it here.)
bootGame(root, { simulationFactory: (spec) => createSimulation(spec) }).catch((err: unknown) => {
  console.error('[DailyRoll] boot failed:', err);
});
